import { useContext } from "react";
import ManagerStoresContext from "../../context/ManagerStores";

const useManagerStores = () => useContext(ManagerStoresContext);

export default useManagerStores;
